/**
 * Side-effect module: initializes Sentry and installs the pre-mount failure
 * handlers. Must stay the first app import of the entry
 * (legacy/web/index.tsx, after polyfills) — module graphs evaluate
 * depth-first, so a top-level throw anywhere in the app graph (the CORE-5604
 * class of crash) fires `error` before the entry body runs. Only a listener
 * installed from a module side effect ahead of that graph can observe it.
 *
 * Crashes inside this module's own dependency graph (Sentry client, env,
 * MountFailure → Popcorn) still evaluate first and are not covered; they need
 * a handler outside the bundle entirely.
 */
import { initSentry } from '~publish/components/ErrorBoundary/PublishSentryClient'
import { setupPreMountErrorHandlers } from '~publish/components/MountFailure'

initSentry()
setupPreMountErrorHandlers()
